module.exports = __webpack_public_path__ + "media/sad_trombone.baad2ca9.mp3";